module.exports = __webpack_public_path__ + "img/vegetable-cream-cheese-roll-ups.ec38a5cc.jpg";